'use client';
import { MobileBackgroundFocusContextType } from '@/types/context';
import { Transition } from '@headlessui/react';
import clsx from 'clsx';
import {
  Fragment,
  useContext,
  useState,
  createContext,
  ReactNode,
} from 'react';

const initMobileBackgroundFocus = {
  show: () => {},
  hide: () => {},
  isOpen: false,
};

export const MobileBackgroundFocusContext =
  createContext<MobileBackgroundFocusContextType>(initMobileBackgroundFocus);

export function MobileBackgroundFocusProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);

  function show() {
    setIsOpen(true);
  }

  function hide() {
    setIsOpen(false);
  }
  return (
    <MobileBackgroundFocusContext.Provider value={{ show, hide, isOpen }}>
      {children}
      <Transition
        as={Fragment}
        show={isOpen}
        enter="tw-transition-all tw-duration-500"
        enterFrom="tw-opacity-0 "
        enterTo="tw-opacity-100 "
        leave="tw-transition-all tw-duration-500"
        leaveFrom="tw-opacity-100"
        leaveTo="tw-opacity-0"
      >
        <div
          className={clsx(
            'tw-fixed tw-inset-0 tw-bg-black/30 tw-z-[9999] tw-transition-all'
          )}
          aria-hidden={true}
        />
      </Transition>
    </MobileBackgroundFocusContext.Provider>
  );
}

export function useMobileBackgroundFocus() {
  return useContext(MobileBackgroundFocusContext);
}
